export default function() {
  return {
    aet: "",
    endereco: "",
    porta: "",
    retrieveSemCompressao: true
  };
}
